const Questions = [
    'Who is your hero?', 
    'If you could live anywhere, where would it be?', 
    'What is your biggest fear?',
    'What was your biggest fear as a child?',
    'What was your favorite vacation as a child?',
    'What is one spot you\'d like to visit for vacation?', 
    'What would you change about yourself if you could?',
    'What makes you the most angry?',
    'What motivates you to work hard?',
    'What is the best part about your career or job?',
    'What is your least favorite part about your career or job?',
    'Which of your accomplishments makes you the most proud?',
    'If you have children, what is their proudest accomplishment(s)?',
    'What is your favorite fiction book?',
    'What is your favorite non-fiction book?', 
    'What was your favorite book as a teenager?',
    'What makes you laugh the most?',
    'Who is your favorite actor?',
    'Who is your favorite acctress?',
    'Who is your favorite comedian?',
    'What is the last movie you saw in the theatre and when?',
    'If you have children, what do they want to be when they grow up?', 
    'If you had one day to do just one thing, what would it be?', 
    'What is your favorite sport to watch?', 
    'What is your favorite sport to play?', 
    'What is your go-to song at Karaoke?', 
    'What do you listen to in the car?', 
    'Would you rather wash dishes, mow the lawn, clean the bathroom, or vacuum the house?', 
    'Would you rather hire someone to help with cooking, cleaning, or yard work?', 
    'If you could eat one meal for the rest of your life, what would it be?', 
    'Who is your favorite author?', 
    'What is your go-to streaming platform?', 
    'What is your favorite social media platform?', 
    'Did you ever have a nickname? What was it?', 
    'Do you like surprises? Why?', 
    'Would you rather go to the beach or the snow?',
    'Would you rather stay in on Friday night or go out?', 
    'What is more appealing; winning the lottery or working a perfect job? Why?', 
    'What are 5 items you would take with you if you were stranded on a deserted island?', 
    'If money did not matter, what would you do?', 
    'If you could travel back in time, what year would you choose?',
    'If you could travel into the future, what year would you choose?', 
    'What is your favorite hobby?', 
    'What is the best gift you\'ve ever been given and why?', 
    'What are your biggest pet peeves?', 
    'Picture yourself five years from now, what is your life like?', 
    'How many pairs of shoes do you own?', 
    'What is your ideal super power?', 
    'What is the first thing you do once you win the lottery?', 
    'If you could go back in time and change one thing, what would it be?', 
    'How many pillows do you sleep with?', 
    'What is the longest you\'ve gone without sleep and why?', 
    'Would you rather be the best looking person in your friend group or the smartest?', 
    'When is the last time you bought yourself clothes?', 
    'What is your favorite holiday and why?',
    'What moment in your life made you most nervous?', 
    'What was the last book you read?', 
    'What is your favorite food?', 
    'If there were no health consequences, what would you eat everyday for the rest of your life?', 
    'What is your go-to fast food restaurant?', 
    'What is your favorite family tradition?', 
    'Is the glass half full or half empty?', 
    'What was your favorite subject in high school?',
    'What was your least favorite subject in high school?', 
    'What is the most flattering thing anyone has said to you?', 
    'What is the nicest thing you\'ve done for someone else?', 
    'What is the most unusual thing you have eaten?', 
    'What item of clothing from your past do you wish would come back in style?',
    'Have you ever met anyone famous?', 
    'Are you related to anyone famous?', 
    'What is your favorite song?', 
    'If you could play one instrument flawlessly, which one would it be?',
    'Who was your first celebrity crush?',
    'Who was your first real-life crush?', 
    'If you could invite 5 people to dinner, alive or dead, who would they be?',
    'Do you think you are funny?', 
    'Do you feel like you are brave?', 
    'If you could change careers or jobs, which profession would you choose?', 
    'If you could go back to college for free, what would you study?', 
    'Who knows you best?',
    'What is something you dread doing every day?', 
    'What is the first thing you do when you wake up?', 
    'What is the last thing you do before you fall asleep?', 
    'Do you prefer a firm mattress or soft mattress?', 
    'Would you rather shop online or go to a mall?', 
    'Do you prefer Star Wars or Star Trek?',
    'What was your favorite TV show as a kid?',
    'Who is the person you can talk to about anything?', 
    'Do you feel like you\'re most like your mother or father?', 
    'Is there a skill that you don\'t have, but would like to learn?', 
    'What is your favorite store?', 
    'Do you put gas in your car regularly or do you wait until your tank is on E?', 
    'Would you rather have a gas or electric vehicle?', 
    'Is the grass always greener?', 
    'What are you most passionate about?', 
    'What could you do better?', 
    'Do you have a clean inbox or tons of unread messages?', 
    'Do you have any regrets?', 
    'Do you feel like you are a good friend?', 
    'Would you rather drive fast and get there on time or go slow and be a little late?', 
    'What did you do in the summer during your childhood?', 
    'What is the best sound in the world?', 
    'What is the best feeling?', 
    'Do you listen to any podcasts?', 
    'Would you rather listen to an audiobook or read a hard copy?', 
    'Was music really better "back in the day"?',
    'Do you read the "Terms & Agreements" before clicking \'Accept\'?',
    'Beer, wine, liquor, or none?', 
    'Cold room with a blanket or warm room and no blanket?',
    'Would you rather binge watch a TV show or watch a movie?', 
    'Harry Potter or Lord of the Rings?', 
    'Do you like to sleep with the windows open or closed?', 
    'Do you shut the door to your bedroom when you go to sleep?', 
    'Would you rather make coffee at home or go to a coffee shop?', 
    'Do you feel like you spend too much, too little, or just the right amount time on your phone?', 
    'Do you prefer a Mac or Windows computer?', 
    'Were you ever a member of any fan clubs?', 
    'Did you ever compete in a talent show during school?',
    'Are you still friends with your childhood best friend?', 
    'What has been the most awkward moment in your life?', 
    'What has been the most influential moment of your life that led to where you\'re at now?', 
    'Have you ever been to another country?', 
    'Would you rather road trip or take a flight?', 
    'How many streaming services are you subscribed to?',
    'If there were a movie made about your life, who would play your character?', 
    'Cake or ice cream?', 
    'Would you rather go to a theme park or a water park?', 
    'If you were a breed of dog, what breed would it be and why?', 
    'Do you prefer cats or dogs?', 
    'Who is your favorite Disney princess?', 
    'Do you still have any material items from your childhood?',
    'Would you rather a book have large print and more pages, or small print and fewer pages?', 
    'What show can you binge watch over and over again?', 
    'Do you have any talents that not many people know about?',
    'Top bunk or bottom bunk?', 
    'Would you rather go on a cruise or a hiking expedition?', 
    'What human-made landmark would you most like to visit?', 
    'What is the oldest thing you own?', 
    'What is your go-to dinner when cooking for yourself?', 
    'Do you make the bed when you wake up every morning?',
    'Would you rather leave an event early to beat traffic or stay until the end?', 
    'Coffee or tea?', 
    'Do you put the toilet paper roll on the holder with the flap in front or back?', 
    'Do you snooze your alarm or wake up right away?',
    'What are the best pizza toppings?', 
    'Are you able to relax if the house is dirty?', 
    'If you had $50,000 to donate to charity or a charitable cause, where would the money go?',
    'Pancakes or eggs?', 
    'Would you rather live in the country or a big city?',
    'What website or application can you not live without?', 
    'Would you rather watch a sunrise or a sunset?', 
    'On a plane, do you prefer the aisle, middle, or window seat?',
    'Have you ever grown any food from seed? What was it?',
    'What is the dumbest purchase you\'ve ever made?', 
    'What was the best investment you\'ve ever made?', 
    'If you could go back and give your 18 year old self a piece of advice, what would it be?', 
    'Do you have a professional mentor, who is it?', 
    'What is one thing you wish you would have done 10 years ago?', 
    'What is the most embarrasing thing that has ever happened to you?',
    'How long have you known your best friend?', 
    'What is the best episode of your favorite TV show?', 
    'Who is your favorite character from a book?', 
    'Is soda better in a can or a bottle?', 
    'Is there a band or musical artist that you used to love, but now don\'t like?',
    'What is your favorite restaurant? What do you order there?', 
    'What is something you always procrastinate?',
    'What is something you\'re happy you\'ll never have to do again?',
    'Do you believe everything happens for a reason?', 
    'If you could pick one age to live over again, what age would it be?', 
    'How would you describe your perfect day?', 
    'Do you usually follow your head or your heart?', 
    'Would you like to be famous? Why or why not?', 
    'Is there something that you\'ve dreamt of doing but never have?', 
    'If your house caught fire and you had time to save one thing (outside of loved ones and pets) what would it be?', 
    'Where would you like to live once you retire?', 
    'What makes you most excited about getting older?', 
    'If you traveled 20 years to the future and could ask yourself one question, what would it be?', 
    'What was the most significant turning point in your life?', 
    'Did you have any pets growing up?', 
    'What is the most cringe worthy thing you wore in public when you were younger?', 
    'When you\'re having a bad day, what helps you feel better?', 
    'Did you have a role model growing up? If so, who was it?', 
    'What is your dream job?', 
    'What is the oldest thing in your refrigerator?', 
    'Who was your favorite teacher in school and why?', 
    'What was your favorite toy or game as a kid?', 
    'What is your first memory?', 
    'What is your best childhood memory?', 
    'Are you particular proud of any of your friend\'s accomplishments? Which ones?',
    'Do you feel like a leader or a follower?', 
    'When was the hardest you have ever laughed?', 
    'What book would you like to see made into a movie?', 
    'Who is the kindest person you\'ve ever met?',
    'What fictional character do you wish were real?', 
    'Have you ever broken any bones? If so, which ones and how?', 
    'Which musical artist would write the score to the movie about your life?', 
    'What movie or TV line do you repeat the most?',
    'Are there any books or movies that are generally loved but you don\'t particularly enjoy?', 
    'What movie needs a sequel?', 
    'Did you participate in any after school sports or activities?', 
    'Are there any songs that you have completely memorized?', 
    'If you were the only human left on Earth, what would you do?', 
    'What is the best smell in the world?', 
    'What is the worst thing you did as a kid?', 
    'If you could read only one person\'s mind, whose would it be?', 
    'If you were to start a business tomorrow, what would it be?', 
    'If people were to judge you by your looks, what do you assume they would think?', 
    'If your home lost electricity for a day, what would you do for fun?', 
    'Would you rather camp on the beach or stay in a hotel overlooking the beach?',
    'What is your favorite board game?',
    'Have you ever been tricked into believing anything?', 
    'Have you ever been in a serious situation but couldn\'t stop laughing?', 
    'If you could meet one person living today, who would it be?', 
    'Do you believe in ghosts?', 
    'If you had to wear just one color for the rest of your life, what would it be?',
    'What is the first thing you do after getting home from a long vacation?', 
    'If you could trade lives with any person living today, who would it be?', 
    'Are you a gambler?', 
    'What is the fanciest event you\'ve ever attended?', 
    'Who is your arch nemesis?', 
    'Do you underpack or overpack for vacations?',
    'What is the most memorable TV commercial you\'ve ever seen?', 
    'If you could have a front-row seat to any major historical event, what would it be?', 
    'Would you keep 3 wishes for yourself or give your 3 wishes to someone else? Why?', 
    'Do you believe in horoscopes?', 
    'If you had the opportunity to live forever, would you do it?',
    'If you could grant one other species the ability to speak your language, which species would it be?',
    'What is one material item you feel you can\'t live without?',
    'What would you name your yacht if you had one?', 
    'Have you ever sided with the villain in book, movie, or TV show?', 
    'Would you rather mediocre at a lot of things, or the best at one thing?',
    'What is the last rabbit hole you fell into online?', 
    'What is the most useless talent you have?', 
    'If you were awarded $10,000 would you save it, spend it, or both?', 
    'Do you have any superstitions? What are they?', 
    'If you could ask your pets 3 questions and they answer, what would they be?', 
    'Do you prefer to ride in the front, middle, or back of the roller coaster?', 
    'Would you ever go skydiving?', 
    'What is the biggest adrenaline rush you\'ve ever experienced?', 
    'If you could change your height, would you?', 
    'Do you have any unique phobias?', 
    'Is there anything that makes you jealous?', 
    'Have you ever mentored anyone in their life and/or career?', 
    'Have you ever broken anything and not told anybody?', 
    'What do you feel is the most attractive part about your personality?', 
    'What childish things do you still enjoy doing?', 
    'What was your first job and how much did it pay?', 
    'Do you have any recurring dreams?', 
    'If you are unable to sleep, what is usually keeping you awake at night?', 
    'What is your favorite concert?', 
    'Would you rather go to a packed concert or intimate performance?', 
    'Do you believe in any conspiracy theories?', 
    'Do you believe in alien life?',
    'What would you consider your biggest accomplishment in life?', 
    'What household chore do you dislike the most?', 
    'What are 3 songs that are necessary on your road trip playlist?', 
    'What do you take with you on a plane if you\'re traveling by yourself?', 
    'Is there a story behind your name?', 
    'Which extinct animal would you like to bring back?', 
    'Which famous quote has impacted your life the most?',
    'What hairstyle from your past makes you cringe now?', 
    'Have you ever thrown anything away that ended up being very valuable?', 
    'What is your favorite day of the week?',
    'What is the worst food you\'ve ever tasted?', 
    'Have you ever "judged a book by its cover" only to learn you were incorrect?', 
    'Do you feel like you have a good work ethic?', 
    'What was the biggest lie you told your parents during your teenage years?', 
    'What is the biggest challenge you have overcome?', 
    'Would you ever get plastic surgery? If so, what would you have done?',
    'What is the worst sound?', 
    'Have you had a near-death experience?', 
    'Who is your favorite athlete and why?', 
    'Do you have a favorite pro or college sports team?',
    'What is your hometown known for?', 
    'Have you ever allowed yourself to be pressured into something you didn\'t want to do?', 
    'Are there any stories from history that you feel should be a movie?', 
    'Do you think you are creative?', 
    'What is your favorite genre of music?', 
    'What is something that you don\'t quite understand but are too afraid to ask about?', 
    'Who do you think is your celebrity look-a-like?', 
    'Do you prefer an Apple or Android phone?', 
    'Have you ever been in the back of police car? When and why?', 
    'Do you feel like people misunderstand anything about you? If so, what is it?', 
    'What is the longest road trip you\'ve ever taken?', 
    'Would you rather do-it-yourself or hire an expert?', 
    'What TV show did you watch most as a kid?', 
    'Would you rather meet your 3rd-great-grandparents or your 3rd-great-grandchildren?', 
    'If you could change one thing about the world, what would it be?', 
    'What is one habit you have that you\'d like to break?', 
    'If you could win gold in any Olympic sport, what would it be?', 
    'If you could be the world expert in any subject, what would it be?', 
    'What food or drink reminds you of your childhood?', 
    'What is a recent trend you weren\'t on board with?', 
    'Did your class have a Senior Trip in high school? If so, where did you go?', 
    'Have you ever broken the law?',
    'If you had the whole world\'s attention for 30 seconds, what would you say?', 
    'What famous person do you feel like you would get along with really well?', 
    'Where is your favorite spot outside your home to relax?', 
    'What was the most memorable party you have ever attended?', 
    'Do you enjoy any unusual food combinations?', 
    'Who is the most embarrassing person you had a crush on?', 
    'Have you ever lied or exaggerated anything to impress anyone?', 
    'How do other people know that you\'re upset?', 
    'What topic could you easily discuss for hours?', 
    'Do you prefer texting or calling your friends?',
    'What is one healthy habit you would like to develop?', 
    'Do you have any habits that you picked up from your parents?', 
    'What was your favorite birthday during your childhood?', 
    'What is the best food you have ever eaten?', 
    'Do you have trouble admitting when you are wrong?', 
    'What is one thing that you have recently changed your opinion on?', 
    'What would the title of your autobiography be?', 
    'What do you consider to be your personal calling?', 
    'What is your most treasured memory?', 
    'Is there anyone from your past that you would like to reconnect with?', 
    'What person do you know personally that you admire most?', 
    'Is there a moment in your life that you would like to do over?', 
    'If you could relive one day of your life, what day would you choose?', 
    'What is the best business idea you have ever had?', 
    'What is one piece of technology you wish had not been developed?', 
    'Has anyone ever told you that you would not succeed?', 
    'If you could remove one word from the English language, what would it be?', 
    'What is the most thoughtful gift you have ever received?', 
    'What song immediately reminds you of a particular time in your life?', 
    'What is the strangest coincidence that has ever happened to you?', 
    'What is your favorite story to tell?', 
    'Do you hold any unpopular opinions? If so, what are they?', 
    'Has a book or movie changed your life?', 
    'Have you ever fallen for a scam? If so, what happened?',
    'What is something that you are always willing to spend extra money on?', 
    'What do you believe is overrated?', 
    'What do you believe is underrated?', 
    'Do you consider yourself an expert in any particular field?', 
    'What is the best kind of weather?', 
    'What scientific discovery or breakthrough do you hope is made in your lifetime?', 
    'Have you ever accidentally said "I love you" to anyone?', 
    'Have you ever cheated in a board or card game?', 
    'If you could hang one original piece of artwork in your home, what would it be?', 
    'What ficitional workplace would you like work at?', 
    'Who is the best boss you have ever had and why?', 
    'What is one bad habit that would be a deal breaker for a desk mate at work?', 
    'Have you ever been fired? If so, why?',
    'Have you ever had any unique jobs? What were they?', 
    'Where can one get the best coffee?',
    'Do you put sugar, cream, or anything else in your coffee?',
    'Would you rather watch an action movie or comedy?', 
    'How many different countries have you visited?', 
    'How many difference cell phone numbers have you had in your life?', 
    'Would you rather spend all day Sunday cooking and prepping meals for the whole week, or an hour everyday making food?',
    'Would you rather write with a pen or a pencil?', 
    'Are you organized?', 
    'Outside of your family, what person have you known the longest?', 
    'What is the furthest you\'ve ever walked or ran in a day?', 
    'What is your favorite planet?', 
    'Have any books changed your life?',
    'Do you like to fall asleep to complete silence or some type of music or sound?', 
    'How many functional phone chargers are in your house?',
    'Do you keep your phone on silent or loud?', 
    'What do you do if an unknown number calls you?', 
    'What is your favorite breakfast cereal?', 
    'Super Mario or Zelda?', 
    'What time do you usually wake up?', 
    'What time do you generally go to bed?', 
    'If you were a wrestler, what would your entrance music be?', 
    'Do you name your car? If so, what is it?', 
    'Are there any foods that you disliked as a kid but love now?', 
    'What is the worst job you have ever had?', 
    'What band from the past would you like to see perform in their prime?', 
    'What is your favorite dessert?', 
    'What is your cell phone wallpaper?', 
    'Do you have any scars? How did you get them?', 
    'What one feature that you would like to add to your home?',
    'Would you rather explore space or the bottom of the ocean?', 
    'Who is the messiest person you know?',
    'Do you make New Years Resolutions?', 
    'What topic could you give a 30-minute presentation on with no preparation?', 
    'What do you wish you would have learned a long time ago?',
    'What is the most interesting period in human history?', 
    'What do you spend too much money on?', 
    'What problem do you want technology to solve?', 
    'What is your preferred way of wasting time on the internet?', 
    'What is something that you thought would be easy but was not?', 
    'What was the biggest mistake you made at work?', 
    'Can you describe your perfect day?', 
    'Who is the most competetive person you know?', 
    'What TV show, movie, or book are you hooked on at this moment?',
    'What is the last goal you achieved?', 
    'What are some common misconceptions about your job?', 
    'What is the best cake you have ever eaten?', 
    'What is the best thing about the city or town you live in?', 
    'Are we living in a simulation?', 
    'What is something you\'re looking forward to?', 
    'Do you use "baby talk" when talking to dogs or cats?', 
    'How long have you had your current phone?', 
    'What in your life could use some upgrading?',
    'What food did you last have delivered to you?', 
    'Do you reheat pizza in the microwave or the oven?',
    'If it were raining food, what food would you want it to rain?',
    'Do you keep your phone consistently charged or only charge when it gets really low on battery?',
    'Would you rather have an extra hand or an extra leg?', 
    'Do you prefer self-checkout or an actual cashier?'
]

export default Questions